import platformDetection from '../../components/utils/PlatformDetection';
import storeManager from "../../store/StoreManager";
import modeType from "../../constants/ModeConstants";

const mouseUtils = {
    isCanvasAction: false,
    mouseDownTime: 0,
    mouseUpTime: 0,
    isDragEnd: false,
    isFirstMarkerFocus: true,
    activeElement: '',

    rejectMouseEvent(event) {
        var isTouchEvent = false;

        if (event.touches != undefined)
            isTouchEvent = true;

        if (isTouchEvent == true) {
            // stop touch event ... the also the corresponding mouse event is stopped
            event.preventDefault();
        }

        return false;
    },
    getTouchPosition(e) {
        if (e.clientX != undefined) { // is MouseEvent
            return {x: e.clientX, y: e.clientY};
        } else {
            if (e.touches.length > 0)
                return {x: e.touches[0].clientX, y: e.touches[0].clientY};
            else
                return {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY};
        }
    },
    getLocalPosition(e, target, isOy = true) {
        var touchPoint, local, global;

        if (isOy) {
            if (e.offsetY != undefined) // is MouseEvent
                return e.offsetY;
            else {
                if (e.touches.length > 0)
                    touchPoint = e.touches[0];
                else
                    touchPoint = e.changedTouches[0];

                if (!touchPoint || !target)
                    return 0;

                local = touchPoint.clientY;
                global = target.getBoundingClientRect().top;

                return local - global;
            }
        } else {
            if (e.offsetX != undefined) // is MouseEvent
                return e.offsetX;
            else {
                if (e.touches.length > 0)
                    touchPoint = e.touches[0];
                else
                    touchPoint = e.changedTouches[0];

                if (!touchPoint || !target)
                    return 0;

                local = touchPoint.clientX;
                global = target.getBoundingClientRect().left;

                return local - global;
            }
        }
    },

    isChangeSlidePositionMode: false,
    holdTimerVar: undefined,
    startDrag: undefined,
    touchPosition: undefined,
    refreshScrollFunction: undefined,
    changeSlideFunction: undefined,

    pressDownAndHold(callBackfunction, touchPosition, changeSlideFunction) {
        if (platformDetection.isIOS() == false)
            return;

        this.changeSlideFunction = changeSlideFunction;
        this.startDrag = callBackfunction;
        this.touchPosition = touchPosition;

        //this.resetSlidePositionMode();
        this.holdTimerVar = setTimeout(this.activateChangeSlidePositionMode.bind(this), 1.5 * 1000);
    },
    activateChangeSlidePositionMode() {
        this.isChangeSlidePositionMode = true;
        this.holdTimerVar = undefined;

        if (this.startDrag && this.touchPosition)
            this.startDrag(this.touchPosition);
    },
    resetSlidePositionMode(offsetX, offsetY) {
        if (platformDetection.isIOS() == false)
            return;

        this.isChangeSlidePositionMode = false;

        if (this.refreshScrollFunction)
            this.refreshScrollFunction();

        if (this.holdTimerVar)
            clearTimeout(this.holdTimerVar);

        this.checkIfIsClick(offsetX, offsetY);
    },
    checkIfIsClick(offsetX, offsetY) {
        const range = 20;

        if (Math.abs(offsetX) < range && Math.abs(offsetY) < range) { // it's a click
            if (this.changeSlideFunction != undefined)
                this.changeSlideFunction();
        }
    },
    isActive() {
        if (platformDetection.isIOS() == false)
            return true;

        return this.isChangeSlidePositionMode;
    },

    isKeyboardShortcut: false,

    setFocusSequence() {
        if (platformDetection.isIOS())
            return;

        let isSearchContext = (storeManager.getState().menu.contextMode === modeType.SEARCH_CONTEXT);

        if (isSearchContext)
            return;

        setTimeout(function() {
            var isMainUniverse = storeManager.getState().menu.isMainUniverse;
            var isThemesVisible = storeManager.getState().menu.isUniversesVisible;
            var element;

            if (isMainUniverse)
                element = document.getElementById('firstUniverseElement');
            else
            if (isThemesVisible)
                element = document.getElementById('firstThemeElement');
            else
                element = document.getElementById('backgroundElement');

            if (element)
                element.focus();
        }.bind(this), 100);
    }
};

export default mouseUtils;




/** WEBPACK FOOTER **
 ** ./src/components/utils/MouseUtils.js
 **/